<div
  *ngIf="cs.vm$ | async as vm"
  [dgxGaContainer]="{ eventCategory: 'payment details form' }"
  class="paysafe-form"
>
  <form
    *ngIf="vm.form"
    (submitted)="onFormSubmit($event)"
    [dgxFormDisabled]="vm.purchasing || vm.validatingCardDetails"
    [dgxTestHook]="testHooks.Form"
    [formGroup]="vm.form"
    dgxFormSubmit
    dgxGaFormSubmit
  >
    <dgx-form-fieldset [dgxFormFieldset]="vm.cmsData.addressFieldset">
      <dgx-form-row [dgxQmSanitise]="'block'">
        <ng-container
          *ngFor="let addressLine of vm.formValue.address | dgxAddressToArray"
        >
          {{ addressLine }}<br />
        </ng-container>
      </dgx-form-row>
    </dgx-form-fieldset>

    <dgx-form-fieldset [dgxFormFieldset]="vm.cmsData.billingAddressFieldset">
      <dgx-form-row>
        <dgx-form-additional-address
          [address]="vm.formValue.address"
          [sameAsAddressCheckboxLabel]="
            vm.cmsData.billingAddressFieldset.billingAddressSameAsAddressField
              .fieldLabel
          "
          formGroupName="billingAddress"
        />
      </dgx-form-row>
    </dgx-form-fieldset>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.accountNameField"
        [dgxTestHook]="testHooks.NameOnCard"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="accountName"
      >
        <dgx-form-text-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.cardNumberField"
        [dgxTestHook]="testHooks.CardNumber"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="cardNumber"
      >
        <checkout-paysafe-form-field
          [dgxQmSanitise]="'block'"
          [field]="vm.fields?.cardNumber"
          [fieldId]="'cardNumber'"
        />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.expiryDateField"
        [dgxTestHook]="testHooks.ExpiryDate"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="expiryDate"
      >
        <checkout-paysafe-form-field
          [dgxQmSanitise]="'block'"
          [field]="vm.fields?.expiryDate"
          [fieldId]="'expiryDate'"
        />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row class="mb-6">
      <dgx-form-field
        [dgxFormField]="vm.cmsData.cvvField"
        [dgxTestHook]="testHooks.CVV"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="cvv"
      >
        <checkout-paysafe-form-field
          [dgxQmSanitise]="'block'"
          [field]="vm.fields?.cvv"
          [fieldId]="'cvv'"
        />
      </dgx-form-field>
    </dgx-form-row>

    <ng-container
      *dgxBasketHasSelectedProductType="
        productType.BoilerCare;
        else applianceCareSection
      "
    >
      <checkout-protection-start-summary-panel
        [body]="vm.cmsData.protectionStartSummaryPanelBodyBoilers"
        [title]="vm.cmsData.protectionStartSummaryPanelTitleBoilers"
      />
    </ng-container>

    <ng-template #applianceCareSection>
      <checkout-protection-start-summary-panel
        [body]="vm.cmsData.protectionStartSummaryPanelBodyWhiteGoods"
        [title]="vm.cmsData.protectionStartSummaryPanelTitleWhiteGoods"
      />
    </ng-template>

    <checkout-terms-and-conditions-fieldset
      *dgxFeatureEnabled="termsAndConditionsFeature"
      [quotes]="vm.selectedQuotes"
      class="mt-6"
    />

    <dgx-form-row *ngIf="vm.monthlyRenewalVisible">
      <dgx-form-field
        [dgxFormField]="vm.cmsData.monthlyRenewalField"
        dgxGaFormField
        formControlName="monthlyRenewal"
      >
        <dgx-form-checkbox />
      </dgx-form-field>
    </dgx-form-row>

    <checkout-paperless-preference-fieldset
      *ngIf="vm.cmsData.paperlessPreferenceFieldset as cmsData"
      [dgxFormFieldset]="cmsData"
      [paperlessPreferenceBanner]="cmsData.paperlessPreferenceBanner"
      [paperlessPreferenceField]="cmsData.paperlessPreferenceField"
    />

    <dgx-form-submit-button
      [loading]="vm.purchasing || vm.validatingCardDetails"
      class="my-6"
    >
      {{ 'CARD_FORM_SUBMIT' | translate }}
    </dgx-form-submit-button>

    <dgx-components-loading-overlay *ngIf="vm.loading" @fadeOut />
  </form>
</div>
